import './i18n/i18n';

import { fetchServerErrors } from '@mocks/errors/fetchWithErrors.mock.ts';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Toast, TooltipProvider } from '@vidacamara/orange-ui';
import { AnalyticsProvider, ClarityProvider } from '@vidacamara/orange-utils';
import { lazy, Suspense } from 'react';
import { HelmetProvider } from 'react-helmet-async';

import { mockWorker } from './msw/browser.ts';
import { AppRoutes } from './routes/app.router.tsx';

const ReactQueryDevtoolsProduction = lazy(() =>
	import('@tanstack/react-query-devtools/production').then((d) => ({
		default: d.ReactQueryDevtools,
	})),
);

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
			retry: false,
		},
	},
});

if (import.meta.env.VITE_MOCK === 'true') mockWorker.start();
const GA_TRACKING_ID = import.meta.env.VITE_GA_TRACKING_ID;
const CLARITY_ID = import.meta.env.VITE_CLARITY_ID;

const App = ({ disableDevtools = false, ...props }: any) => {
	return (
		<AnalyticsProvider trackingId={GA_TRACKING_ID}>
			<ClarityProvider id={CLARITY_ID}>
				<TooltipProvider>
					<Toast>
						<HelmetProvider>
							<QueryClientProvider client={queryClient}>
								<AppRoutes {...props} />

								{!disableDevtools && import.meta.env.DEV && (
									<ReactQueryDevtools
										initialIsOpen
										errorTypes={[
											{
												name: 'serverError',
												initializer: fetchServerErrors,
											},
										]}
									/>
								)}
								{!disableDevtools && import.meta.env.MODE === 'local-dev' && (
									<Suspense fallback={null}>
										<ReactQueryDevtoolsProduction />
									</Suspense>
								)}
							</QueryClientProvider>
						</HelmetProvider>
					</Toast>
				</TooltipProvider>
			</ClarityProvider>
		</AnalyticsProvider>
	);
};

export default App;
